import { render } from "./CaricamentoSwitchIn.vue?vue&type=template&id=244237c8"
import script from "./CaricamentoSwitchIn.vue?vue&type=script&lang=js"
export * from "./CaricamentoSwitchIn.vue?vue&type=script&lang=js"

import "./CaricamentoSwitchIn.vue?vue&type=style&index=0&id=244237c8&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__